import { uploadCSV } from '../../../api/configuracio/control/uploadCSV';
import createApiModule from '../../createApiModule';

const uploadCSVModule = createApiModule({
  name: 'uploadCSV',
  apiMethod: uploadCSV,
  onSuccess: () => ({
    message: "El fitxer CSV s'ha pujat correctament.",
  }),
  onError: () => ({
    message: 'Error pujant el fitxer CSV',
  }),
  onValidationError: () => ({
    message: 'Error pujant el fitxer CSV',
  }),
});

export const {
  start: upload,
  success: uploadOk,
  error: uploadKo,
} = uploadCSVModule.slice.actions;

export default uploadCSVModule;
